import { ErrorType } from '@shared/integrations/utils/mutator/custom-instance.ts';
import { IError } from '@shared/integrations/taf-api/v2/models';
import AlertBox from '@shared/components/AlertBox.tsx';

interface IAccommodationBookingError {
    errors: ErrorType<IError[]>;
}

const AccommodationBookingError = ({}: IAccommodationBookingError) => {
    return (
        <div className='mb-4'>
            <AlertBox
                theme='danger'
                heading='Det gick inte att skapa en bokning'
            >
                <p>Det kan bero på något av följande:</p>
                <ul className='ml-1'>
                    <li>Du har redan en aktiv bokning.</li>
                    <li>Driftstörningar på Mina Sidor.</li>
                </ul>
                <p>
                    Behöver du ytterligare hjälp eller har frågor kontakta oss på:{' '}
                    <a
                        href='tel:010-480 30 00'
                        className='text-nowrap'
                    >
                        010-480 30 00
                    </a>
                    .
                </p>
            </AlertBox>
        </div>
    );
};
export default AccommodationBookingError;
